import React, { useState } from 'react';
import { observer } from "mobx-react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { FaQuestionCircle } from "react-icons/fa";

import MoreInfoBox from '../MoreInfoBox'
import {RegionSummarySectionTableRow} from './RegionSummarySectionTable';

import StatecountyAQIAreachart from '../StatecountyAQIAreachart';
import CountyPM25Multispline from '../CountyPM25Multispline';
import USstatePM25InfectionBubblechart from '../USstatePM25InfectionBubblechart'
import StateSmokeSpline from '../StateSmokeSpline';
import Link from '../Link'

import {regionReportsTabDataStore} from '../../store/apiStores'
import { roundAndFormat } from '../../lib/strFormatting'

export default observer((props) => {
    if (!regionReportsTabDataStore.data) {
        return null;
    } else if (!regionReportsTabDataStore.data.yesterday_aqi_assessment
            && !regionReportsTabDataStore.data.two_days_ago_aqi_assessment
            && !regionReportsTabDataStore.data.three_days_ago_aqi_assessment) {
        return (
            <div>
                <h3>Air Quality - Particulates</h3>
                <div style={{fontStyle: 'italic', padding: '10px 25px'}}>No air quality data.</div>
            </div>
        )
    }

    return (
        <div>
            <h3>Air Quality - Particulates</h3>
            <Container className="region-summary-section-table" fluid={true} borderless={true}>
                <Row className="header">
                    <Col xs={12} lg={3} className="region-page-sum-questions"></Col>
                    <Col xs={12} lg={3} className="region-page-sum-metric">Metric</Col>
                    <Col xs={6} lg={1} className="region-page-sum-value">Value</Col>
                    <Col xs={6} lg={2} className="region-page-sum-assessment">
                        Assessment <Link to="/tracking/ref/aq" target="_blank"><FaQuestionCircle /></Link>
                    </Col>
                    <Col xs={6} lg={3} className="region-page-sum-distribution">Distribution Within Area<br /><font className="small">(by population)</font></Col>
                </Row>
                <RegionSummarySectionTableRow
                    field='yesterday_aqi'
                    isPercent={false}
                    question='What is the current overall level of air quality impacts?'
                    metric="% population in each category based on yesterday's max(NowCast category) from permanent networks"
                    value="see distribution"
                    distributionsComponent={YesterdayAqiDistributions}
                />
                <ChangeInAqiLevelsRow />
                {/*
                <RegionSummarySectionTableRow
                    isPercent={false}
                    question='Are there indications of higher impacts including in temporary or low-cost sensor values?'
                    metric='% of all monitors in each max(NowCast category) over past 24 hours'
                    value="see distribution" />
                */}
            </Container>
            <MoreInfoBox>
                <RegionSummaryAirQualitySectionGraphics
                    region={props.region}
                    state={props.state}
                    county={props.county} />
            </MoreInfoBox>
        </div>
    )
})

function YesterdayAqiDistributions(props) {
    return (
        <div>
            <div style={{paddingTop: '5px'}}><span style={{fontWeight: 'bold', 'fontStyle': 'italic'}}>Yesterday</span></div>
            {props.distributions.map(function(d, i){
                return <div class="category">{d.value} ({d.title.replace(/ \(.*$/, '')})</div>
            })}
        </div>
    )
}

let ChangeInAqiLevelsRow = observer((props) => {
    let data = regionReportsTabDataStore.data;

    let colorHex = (!data)? ('') : (data.aqi_assessment_difference_assessment_color_code);
    let value = 'see distribution';
    let assessment = (!data)? ('') : (data.aqi_assessment_difference_assessment);
    let assessmentCaption = (!data)? ('') : (data.aqi_assessment_difference_assessment_caption);
    let twoDayAgoAssessment = (!data)? ('') : (data.two_days_ago_aqi_assessment);
    let threeDayAgoAssessment = (!data)? ('') : (data.three_days_ago_aqi_assessment);

    let distributions = []
    if (data && data.two_days_ago_aqi_distributions && data.three_days_ago_aqi_distributions) {
        let twoDayDist = data.two_days_ago_aqi_distributions.sort((a, b) => {return a.level - b.level});
        let threeDayDist = data.three_days_ago_aqi_distributions.sort((a, b) => {return a.level - b.level});
        distributions = twoDayDist.map((twoDay, i) => {
            let threeDay = threeDayDist[i];
            return `${roundAndFormat(twoDay.population_pct)}% / ${roundAndFormat(threeDay.population_pct)}% (${twoDay.assessment})`;
        })
    }

    return (
        <Row>
            <Col xs={12} lg={3} className="cell region-page-sum-questions">Is the level increasing or decreasing?</Col>
            <Col xs={12} lg={3} className="cell region-page-sum-metric">change in assessment rating from previous 2 days</Col>
            <Col xs={6} lg={1} className="cell region-page-sum-value" style={{backgroundColor: colorHex}}>
                <div>{value}</div>
            </Col>
            <Col xs={6} lg={2} className="cell region-page-sum-assessment" style={{backgroundColor: colorHex}}>
                <div className="bigbold">{assessment}</div>
                <div>{assessmentCaption}</div>
            </Col>
            <Col xs={12} lg={3} className="cell region-page-sum-distribution">
                <div>
                    <div class="d-none d-lg-block">
                        <DistributionsSection distributions={distributions}
                            twoDayAgoAssessment={twoDayAgoAssessment}
                            threeDayAgoAssessment={threeDayAgoAssessment} />
                    </div>
                    <div class="d-xs-block d-lg-none">
                        <MoreInfoBox toggleText="Distribution" startCollapsed={true}>
                            <DistributionsSection distributions={distributions}
                                twoDayAgoAssessment={twoDayAgoAssessment}
                                threeDayAgoAssessment={threeDayAgoAssessment} />
                        </MoreInfoBox>
                    </div>
                </div>
            </Col>
        </Row>
    )
})

let DistributionsSection = (props) => {
    return (
        <div>
            <div><span style={{fontWeight: 'bold', 'fontStyle': 'italic'}}>Two Days Ago</span>: {props.twoDayAgoAssessment}</div>
            <div><span style={{fontWeight: 'bold', 'fontStyle': 'italic'}}>Three Days Ago</span>: {props.threeDayAgoAssessment}</div>
            <div style={{paddingTop: '5px'}}><span style={{fontWeight: 'bold', 'fontStyle': 'italic'}}>Two Days Ago / Three Days Ago Levels</span></div>

            {props.distributions.map(function(d, i){
                return <div class="category">{d}</div>
            })}
        </div>
    )
}

function RegionSummaryAirQualitySectionGraphics(props) {
    if (props.county) {
        return (
            <Container fluid={true} style={{paddingTop: '20px'}}>
                <Row>
                    <Col>
                        <Tabs defaultActiveKey="pct" variant="pills">
                            <Tab eventKey="pct" title="Population Percentage">
                                <StatecountyAQIAreachart county={props.county} />
                            </Tab>
                            <Tab eventKey="pop" title="Population">
                                <StatecountyAQIAreachart county={props.county} raw_data={true} />
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
                {/* commented out
                <Row>
                    <Col>
                        <CountyPM25Multispline county={props.county} />
                    </Col>
                </Row>
                */}
            </Container>
        )
    } else if (props.state) {
        return (

            <Container fluid={true} style={{paddingTop: '20px'}}>
                <Row>
                    <Col>
                        <Tabs defaultActiveKey="pct" variant="pills">
                            <Tab eventKey="pct" title="Population Percentage">
                                <StatecountyAQIAreachart state={props.state} />
                            </Tab>
                            <Tab eventKey="pop" title="Population">
                                <StatecountyAQIAreachart state={props.state} raw_data={true} />
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StateSmokeSpline state={props.state} />
                    </Col>
                </Row>
            </Container>
        )
    } else {
        return (

            <Container fluid={true} style={{paddingTop: '20px'}}>
                <Row>
                    <Col>
                        <Tabs defaultActiveKey="pct" variant="pills">
                            <Tab eventKey="pct" title="Population Percentage">
                                <StatecountyAQIAreachart region={props.region} />
                            </Tab>
                            <Tab eventKey="pop" title="Population">
                                <StatecountyAQIAreachart region={props.region} raw_data={true} />
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <StateSmokeSpline region={props.region} />
                    </Col>
                </Row>
            </Container>
        )
    }
}
